import { Box, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, FormLabel, RadioGroup } from "@mui/material";
import { RadioCard } from "../../../core/components/RadioCard";
import { IFluxoContexto } from "../../interface/IFluxoContexto";
import { TipoAnexoDescricao } from "../../enum/TipoAnexoPedido";
import { useState } from "react";

export interface IImprimirModal {
    fluxoContexto: IFluxoContexto;
    open: boolean;
    fechar: () => void;
    imprimir: (uuid: string) => void;
    loading: boolean;
}

export const ImprimirModal = ({ fluxoContexto, open, fechar, imprimir, loading }: IImprimirModal) => {
    const [configuracaoComanda, setConfiguracaoComanda] = useState<string | undefined>(undefined);

    const handleFechar = () => {
        setConfiguracaoComanda(undefined);
        fechar();
    }

    const handleImprimir = () => {
        if(!configuracaoComanda) {
            return;
        }

        imprimir(configuracaoComanda);
    }

    return (
        <Dialog open={open} onClose={handleFechar} sx={{ zIndex: 9999 }}>
            <DialogTitle>Imprimir comanda</DialogTitle>
            <DialogContent>
                <FormControl>
                    <FormLabel id="imprimir-anexos">Qual comanda você deseja imprimir?</FormLabel>
                    <RadioGroup
                        aria-labelledby="imprimir-anexos"
                        name="imprimir-anexos-group"
                        value={configuracaoComanda}
                        onChange={(e, value) => setConfiguracaoComanda(value)}
                    >
                        {fluxoContexto?.configuracoesComandas.map(configuracao => {
                            return (
                                <Box sx={{ mt: 2 }}>
                                    <RadioCard
                                        labelTitle={TipoAnexoDescricao[configuracao.tipo]}
                                        labelValue={configuracao.uuid}
                                        key={configuracao.uuid}
                                        selected={configuracao.uuid == configuracaoComanda}
                                        onClick={() => setConfiguracaoComanda(configuracao.uuid)}
                                    />
                                </Box>
                            );
                        })}
                    </RadioGroup>
                </FormControl>
            </DialogContent>
            <DialogActions>
                <Button onClick={handleFechar}>Cancelar</Button>
                <Button variant={!loading ? "contained" : "outlined"} disabled={!configuracaoComanda} onClick={handleImprimir}>
                    {!loading ? "Imprimir" : <CircularProgress size={25} />}
                </Button>
            </DialogActions>
        </Dialog>
    );
}